module.exports = __webpack_public_path__ + "img/stock3.3bede88f.png";